import React from 'react'
import { string, number } from 'prop-types'

function FireIcon({
  className = '',
  width = 16,
  height = 16,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7.44043 1.61569C7.81543 1.10189 8.66699 1.33574 8.66699 1.95553C8.66743 4.64115 13.333 5.23302
        13.333 9.66745C13.3328 12.4243 10.9407 14.6674 8 14.6674C5.05933 14.6674 2.66718 12.4243 2.66699
        9.66745C2.66699 8.13967 3.43904 6.88511 4.18262 6.1528C4.59817 5.74316 5.33301 6.01738 5.33301
        6.58248V8.80905C5.33301 9.72493 6.11095 10.4887 7.08789 10.5005C8.08054 10.5125 8.88867 9.76124
        8.88867 8.83346C8.8882 6.54212 4.0004 6.32972 7.44043 1.61569Z"
        fill="#35424F"
      />
      <path
        d="M7.44043 1.61569C7.81543 1.10189 8.66699 1.33574 8.66699 1.95553C8.66743 4.64115 13.333 5.23302
        13.333 9.66745C13.3328 12.4243 10.9407 14.6674 8 14.6674C5.05933 14.6674 2.66718 12.4243 2.66699
        9.66745C2.66699 8.13967 3.43904 6.88511 4.18262 6.1528C4.59817 5.74316 5.33301 6.01738 5.33301
        6.58248V8.80905C5.33301 9.72493 6.11095 10.4887 7.08789 10.5005C8.08054 10.5125 8.88867 9.76124
        8.88867 8.83346C8.8882 6.54212 4.0004 6.32972 7.44043 1.61569Z"
        fill="#F97066"
      />
      <path
        d="M7.44043 1.61569C7.81543 1.10189 8.66699 1.33574 8.66699 1.95553C8.66743 4.64115 13.333 5.23302
        13.333 9.66745C13.3328 12.4243 10.9407 14.6674 8 14.6674C5.05933 14.6674 2.66718 12.4243 2.66699
        9.66745C2.66699 8.13967 3.43904 6.88511 4.18262 6.1528C4.59817 5.74316 5.33301 6.01738 5.33301
        6.58248V8.80905C5.33301 9.72493 6.11095 10.4887 7.08789 10.5005C8.08054 10.5125 8.88867 9.76124
        8.88867 8.83346C8.8882 6.54212 4.0004 6.32972 7.44043 1.61569Z"
        fill="url(#paint0_radial_288_8391)"
        fillOpacity="0.9"
      />
      <path
        d="M7.44043 1.61569C7.81543 1.10189 8.66699 1.33574 8.66699 1.95553C8.66743 4.64115 13.333 5.23302
        13.333 9.66745C13.3328 12.4243 10.9407 14.6674 8 14.6674C5.05933 14.6674 2.66718 12.4243 2.66699
        9.66745C2.66699 8.13967 3.43904 6.88511 4.18262 6.1528C4.59817 5.74316 5.33301 6.01738 5.33301
        6.58248V8.80905C5.33301 9.72493 6.11095 10.4887 7.08789 10.5005C8.08054 10.5125 8.88867 9.76124
        8.88867 8.83346C8.8882 6.54212 4.0004 6.32972 7.44043 1.61569Z"
        fill="url(#paint1_radial_288_8391)"
        fillOpacity="0.3"
      />
      <path
        d="M7.44043 1.61569C7.81543 1.10189 8.66699 1.33574 8.66699 1.95553C8.66743 4.64115 13.333 5.23302
        13.333 9.66745C13.3328 12.4243 10.9407 14.6674 8 14.6674C5.05933 14.6674 2.66718 12.4243 2.66699
        9.66745C2.66699 8.13967 3.43904 6.88511 4.18262 6.1528C4.59817 5.74316 5.33301 6.01738 5.33301
        6.58248V8.80905C5.33301 9.72493 6.11095 10.4887 7.08789 10.5005C8.08054 10.5125 8.88867 9.76124
        8.88867 8.83346C8.8882 6.54212 4.0004 6.32972 7.44043 1.61569Z"
        fill="url(#paint2_radial_288_8391)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_288_8391"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8 14.6678) rotate(-90) scale(8.33363 6.66643)"
        >
          <stop stopColor="#EE8606" />
          <stop offset="1" stopColor="#EE8606" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_288_8391"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8 1.33398) rotate(90) scale(8.8892 7.11086)"
        >
          <stop stopColor="#EE0606" />
          <stop offset="1" stopColor="#EE0606" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_288_8391"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8 5.77859) rotate(90) scale(9.44478 7.55529)"
        >
          <stop stopColor="#EE4406" />
          <stop offset="1" stopColor="#EE4406" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

FireIcon.propTypes = {
  className: string,
  width: number,
  height: number,
}

export default FireIcon
